import PropTypes from 'prop-types'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper'


import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ComputerCase from '../ComputerCase'
import PhoneCase from '../PhoneCase'
import PictureCard from '../PictureCard'

import styles from './styles'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'


const decorators = [
  memoized,
]

function Portfolio(props) {
  const { projects, locale, swiper, displaySwiperNavigation } = props

  return (
    <div className="container projects">
      <Swiper
      modules={displaySwiperNavigation ? [Navigation] : []}
      navigation={{ prevEl: '.button-prev',nextEl: '.button-next' }}
      preventClicks={false}
      preventClicksPropagation={false}
      breakpoints={{
        0: {
          slidesPerView: 1.3,
          spaceBetween: 30,
          allowTouchMove: true
        },
        720: {
          slidesPerView: 2.3,
          spaceBetween: 25,
          allowTouchMove: true
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 50,
          allowTouchMove: false
        }
      }}
      {...swiper}
      >
        {projects && projects.map((entry, i) => (entry ? (
          <SwiperSlide key={entry.slug}>
            <PictureCard
              thumbnail={entry.thumbnail}
              title={entry.title}
              subTitle={entry.subTitle}
              slug={entry.slug}
              locale={locale}
            />
          </SwiperSlide>
        ) : null))}
        {displaySwiperNavigation && (
          <>
            <button role={'button'} className='button-prev' aria-label={'previous'}><img width={22} height={22} src={'/images/icons/arrow-left-white.svg'} alt={'arrow-left'} /></button>
            <button role={'button'} className='button-next' aria-label={'next'}><img width={22} height={22} src={'/images/icons/arrow-right-white.svg'} alt={'arrow-right'} /></button>
          </>
        )}
      </Swiper>
      <style jsx>{styles}</style>
    </div>
  )
}

Portfolio.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      ...PhoneCase.propTypes,
      ...ComputerCase.propTypes,
    })
  ).isRequired,
  swiper: Swiper.propTypes,
  displaySwiperNavigation: PropTypes.bool,
  locale: PropTypes.string.isRequired,
}

Portfolio.defaultProps = {
  //
}

Portfolio = chainDecorators(decorators, Portfolio)

export default Portfolio
